import { ICreateDepositOrderValues } from '@epi-models/containers/LoadCompanyAccount';
import { createSelector } from 'reselect';

export const getCompanyAccounts = (state): ICreateDepositOrderValues[] =>
  state.apiCompanyAccounts.accounts;

export const getCompanyNotification = (state): boolean =>
  state.apiCompanyAccounts.showNotification;

export const getCompanyInvoicePFD = (state): boolean =>
  state.apiCompanyAccounts.isPrintInvoicePdfForTransferMoney;

export const getMainCompanyAccount = createSelector(
  getCompanyAccounts,
  (accounts: ICreateDepositOrderValues[]): ICreateDepositOrderValues | {} => {
    return (accounts || []).find(v => !v.parentAccountId) || {};
  }
);

export const getMainAvailableBalance = createSelector(
  getMainCompanyAccount,
  account => {
    return (account as ICreateDepositOrderValues).availableBalance || 0;
  }
);
